export default {
  page: {
    title: "문의하기",
    bannerSubtitle: "제품 문의, 견적 요청, 기술 상담 등 무엇이든 문의해 주세요",
    submittedSubtitle: "문의가 접수되었습니다",
    submittedTitle: "문의가 접수되었습니다",
    submittedDesc: "소중한 문의 감사드립니다. 담당자가 확인 후 빠른 시일 내에 회신 드리겠습니다. 긴급한 사항은 전화로 연락 부탁드립니다.",
    contactInfoTitle: "연락처 안내",
    contactInfoDesc: "전화 또는 이메일로 직접 문의하셔도 됩니다. 아래 연락처로 편하게 연락 주세요.",
    tel: "전화",
    fax: "팩스",
    email: "이메일",
    address: "주소",
    onlineTitle: "온라인 문의",
    onlineDesc: "아래 양식을 작성해 주시면 담당자가 확인 후 연락 드립니다.",
    form: {
      company: "회사명",
      companyPlaceholder: "회사명을 입력하세요",
      name: "담당자명",
      namePlaceholder: "담당자명을 입력하세요",
      phone: "연락처",
      phonePlaceholder: "연락처를 입력하세요",
      email: "이메일",
      emailPlaceholder: "이메일을 입력하세요",
      inquiryType: "문의 유형",
      inquiryTypePlaceholder: "문의 유형을 선택하세요",
      inquiryTypes: [
        { value: "product", label: "제품 문의" },
        { value: "quotation", label: "견적 요청" },
        { value: "technical", label: "기술 상담" },
        { value: "sample", label: "샘플 요청" },
        { value: "other", label: "기타" },
      ],
      message: "문의 내용",
      messagePlaceholder: "문의하실 내용을 구체적으로 입력해 주세요. (제품 용도, 필요 수량, 적용 환경 등)",
      messageHint: "최대 500자까지 입력 가능합니다.",
      attachment: "첨부파일 (도면, 사진 등)",
      attachmentHint: "PDF, JPG, PNG, DWG 파일 첨부 가능 (최대 10MB)",
      consent: "개인정보 수집 및 이용에 동의합니다. 수집된 개인정보는 문의 응대 목적으로만 사용되며, 관련 법령에 따라 안전하게 보관됩니다.",
      submit: "문의 접수하기",
      submitting: "접수 중...",
    },
  },
};